import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoMedia from '../../../../theme/promoMedia';

const getAlignment = (props) => {
    switch (props.align) {
        case 'start':
            return 'start';
        case 'center':
            return 'center';
        case 'end':
            return 'end';
    }
};
const getJustify = (props) => {
    switch (props.justify) {
        case 'start':
            return 'flex-start';
        case 'center':
            return 'center';
        case 'end':
            return 'flex-end';
        case 'between':
            return 'space-between';
    }
};
const getDirection = (props) => {
    if (props.flex) {
        if (props.direction === 'column') {
            return 'column';
        }
        return 'row';
    }
    return null;
};
const getTextAlign = (props) => {
    switch (props.textAlign) {
        case 'center':
            return 'center';
        case 'right':
            return 'right';
        default:
            return null;
    }
};
const getBottomIndent = (props) => {
    switch (props.indent) {
        case '4px':
            return '4px';
        case '8px':
            return '8px';
        case '16px':
            return '16px';
        case '24px':
            return '24px';
        case '32px':
            return '32px';
        case '56px':
            return '56px';
        case '64px':
            return '64px';
        case 'adaptive-32-48-64':
            return '32px';
        case 'adaptive-8-12':
            return '8px';
        case 'adaptive-12-16':
            return '12px';
        case 'adaptive-24-32':
            return '24px';
        default:
            return null;
    }
};
const getTabletBottomIndent = (props) => {
    switch (props.indent) {
        case '4px':
            return '4px';
        case '8px':
            return '8px';
        case '16px':
            return '16px';
        case '24px':
            return '24px';
        case '32px':
            return '32px';
        case '56px':
            return '56px';
        case '64px':
            return '64px';
        case 'adaptive-32-48-64':
            return '48px';
        case 'adaptive-8-12':
            return '12px';
        case 'adaptive-12-16':
            return '16px';
        case 'adaptive-24-32':
            return '32px';
        default:
            return null;
    }
};
const getDesktopBottomIndent = (props) => {
    switch (props.indent) {
        case '4px':
            return '4px';
        case '8px':
            return '8px';
        case '16px':
            return '16px';
        case '24px':
            return '24px';
        case '32px':
            return '32px';
        case '56px':
            return '56px';
        case '64px':
            return '64px';
        case 'adaptive-32-48-64':
            return '64px';
        case 'adaptive-8-12':
            return '12px';
        case 'adaptive-12-16':
            return '16px';
        default:
            return null;
    }
};

const Container = styled.div`
    display: ${(props) => (props.flex ? 'flex' : 'block')};
    flex-direction: ${(props) => getDirection(props)};
    align-items: ${(props) => getAlignment(props)};
    justify-content: ${(props) => getJustify(props)};
    flex-wrap: ${(props) => (props.flexWrap ? 'wrap' : null)};
    margin-bottom: ${(props) => getBottomIndent(props)};
    overflow: ${(props) => (props.overflow ? 'hidden' : null)};
    text-align: ${(props) => getTextAlign(props)};
    row-gap: ${(props) => (props.rowGap ? props.rowGap : null)};

    ${promoMedia.tablet744} {
        margin-bottom: ${(props) => getTabletBottomIndent(props)};
    }

    ${promoMedia.desktop1440} {
        margin-bottom: ${(props) => getDesktopBottomIndent(props)};
    }

    &:last-child {
        margin-bottom: ${(props) => (props.lastChildNoMargin ? '0' : null)};
    }
`;

export const PromoRow = (props) => {
    return <Container {...props}>{props.children}</Container>;
};

PromoRow.propTypes = {
    flex: PropTypes.bool,
    flexWrap: PropTypes.bool,
    direction: PropTypes.oneOf(['row', 'column']),
    align: PropTypes.oneOf(['start', 'center', 'end']),
    justify: PropTypes.oneOf(['start', 'center', 'end', 'between']),
    indent: PropTypes.oneOf(['4px', '8px', '16px', '24px', '32px', '56px', '64px', 'adaptive-32-48-64', 'adaptive-8-12', 'adaptive-12-16', 'adaptive-24-32']),
    overflow: PropTypes.bool,
    textAlign: PropTypes.oneOf(['center', 'right']),
    children: PropTypes.any,
    rowGap: PropTypes.string,
    lastChildNoMargin: PropTypes.bool,
};
